import { KeychainHandler } from './plugin';

export default {
  install(Vue) {
    Vue.prototype.$keychain = KeychainHandler;
  }
}
